import { render } from "./DropdownMenu.vue?vue&type=template&id=fe36fc02&scoped=true&ts=true"
import script from "./DropdownMenu.vue?vue&type=script&lang=ts"
export * from "./DropdownMenu.vue?vue&type=script&lang=ts"

import "./DropdownMenu.vue?vue&type=style&index=0&id=fe36fc02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe36fc02"]])

export default __exports__